/**
 * Barra superior: marca (gota de CDTEC + «CDTEC»), pestañas (con ícono), «Nueva tarea» y el menú del perfil.
 *
 * Las pestañas siguen los permisos de la persona (Personas y Configuración, solo administración).
 * En barra angosta (celular) las pestañas se ocultan por CSS y pasan a la sección «Ir a» del menú del
 * avatar (ver MenuPerfil). «Nueva tarea» abre el panel con la dirección `/?tarea=nueva`.
 */
import { NavLink, useNavigate } from 'react-router';
import { useYo } from '../features/auth/sesion';
import { Icono } from './Icono';
import { MenuPerfil } from './MenuPerfil';
import { usePaginasPrincipales, type PaginaPrincipal } from './paginasPrincipales';
import './Encabezado.css';

function Pestana({ a, icono, texto, fin }: PaginaPrincipal) {
  // Con la barra angosta el texto se oculta por CSS: `title` deja el nombre a la vista y al puntero.
  return (
    <NavLink to={a} end={fin} title={texto} aria-label={texto} className="encabezado__pestana">
      <Icono nombre={icono} />
      <span className="encabezado__texto">{texto}</span>
    </NavLink>
  );
}

export function Encabezado() {
  const yo = useYo();
  const navegar = useNavigate();
  const paginas = usePaginasPrincipales();

  return (
    <header className="encabezado">
      <div className="encabezado__barra">
        <div className="encabezado__marca">
          {/* Decorativa: al lado dice «CDTEC». Origen del archivo: docs/arquitectura/web.md. */}
          <img className="encabezado__logo" src="/cdtec-gota.png" alt="" width={23} height={28} />
          CDTEC
        </div>
        <nav aria-label="Principal" className="encabezado__nav">
          {paginas.map((pagina) => (
            <Pestana key={pagina.a} {...pagina} />
          ))}
        </nav>
        <div className="encabezado__der">
          {yo.puedeEscribir && (
            <button
              type="button"
              className="boton boton--primario encabezado__nueva"
              title="Nueva tarea"
              aria-label="Nueva tarea"
              onClick={() => void navegar('/?tarea=nueva')}
            >
              <Icono nombre="mas" />
              <span className="encabezado__texto">Nueva tarea</span>
            </button>
          )}
          <MenuPerfil />
        </div>
      </div>
    </header>
  );
}
